"use client";
import dynamic from "next/dynamic";
import { GoogleTagManager } from "@next/third-parties/google";

const DynamicGoogleTagManager = dynamic(
  () =>
    Promise.resolve(({ gtmId }: { gtmId: string }) => (
      <GoogleTagManager gtmId={gtmId} />
    )),
  { ssr: false, loading: () => null },
);

const GoogleTag = () => {
  return <DynamicGoogleTagManager gtmId="GTM-MVLVNRN9" />;
};

export default GoogleTag;
